import {
  CLIMATE_MONITORING_AGENT,
  FINANCE_MONITORING_AGENT,
  OWNERSHIP_MONITORING_AGENT,
  REGULATION_MONITORING_AGENT,
  REPUTATION_MONITORING_AGENT,
} from 'constants/monitoringAgents';

import type { TMonitoringSubType } from '../interfaces/IAiChatTools';
import type IMonitoringAgentKeys from '../interfaces/IMonitoringAgentKeys';

/**
 * Translation keys of the agent a monitoring session runs and of its unit noun, for the
 * monitoring rows. A sub-type the FE does not know reads as "Monitoring" of "units".
 */
const readMonitoringAgentKeys = (subType: TMonitoringSubType | undefined): IMonitoringAgentKeys => {
  switch (subType) {
    case 'regulation-tracking':
      return { agentKey: REGULATION_MONITORING_AGENT.titleKey, unitCountKey: 'aiChat.tools.monitoringProductCount' };
    case 'media-sentiment':
      return { agentKey: REPUTATION_MONITORING_AGENT.titleKey, unitCountKey: 'aiChat.tools.monitoringSupplierCount' };
    case 'ownership-monitoring':
      return { agentKey: OWNERSHIP_MONITORING_AGENT.titleKey, unitCountKey: 'aiChat.tools.monitoringSupplierCount' };
    case 'financial-risk':
      return { agentKey: FINANCE_MONITORING_AGENT.titleKey, unitCountKey: 'aiChat.tools.monitoringSupplierCount' };
    case 'climate-risk':
      return { agentKey: CLIMATE_MONITORING_AGENT.titleKey, unitCountKey: 'aiChat.tools.monitoringEntityCount' };
    default:
      return { agentKey: 'aiChat.tools.monitoringAgent', unitCountKey: 'aiChat.tools.monitoringUnitCount' };
  }
};

export default readMonitoringAgentKeys;
